module.exports = __webpack_public_path__ + "static/7-ccacb7ff3e15adf771ea93069a060daa.jpg";